<template>
    <b-container fluid>
        <b-row class="">
            <b-col cols="12" class="p-2">
                <h2>{{$t('profil.title')}}</h2>
            </b-col>
            <b-col cols="12" class="p-1">
                <h6> {{$t('profil.user')}}: {{ user.username }}</h6>
            </b-col>
            <b-col cols="12" class="p-1">
                <h6> {{$t('profil.email')}}: {{ user.email }}</h6>
            </b-col>
            <b-col md="3" class="p-4 flex-center flex-column">
                <b-row class="p-2 w-100">
                    <b-btn size="lg" variant="primary" class="w-100" v-b-modal.changePassword>
                        {{$t('profil.button')}}
                    </b-btn>
                </b-row>
            </b-col>
        </b-row>

        <b-modal centered
                 no-close-on-backdrop
                 hide-footer
                 id="changePassword"
                 title="Change password"
                 ok-variant="success">
                 <template v-slot:modal-title>
                    {{$t('profil.modal.title')}}
                </template>
            <b-col md="12">
                <b-form @submit.prevent="changePassword()" data-vv-scope="changePassword">
                    <b-row>
<!--                        <b-col cols="12">-->
<!--                            <b-form-group label="Old password"-->
<!--                                          label-for="oldPassword">-->
<!--                                <b-form-input v-validate="'required'" v-model="user.oldPassword" id="oldPassword" type="password" size="md" name="oldPassword" required></b-form-input>-->
<!--                                <span class="vvError">{{ veeErrors.first('changePassword.oldPassword') }}</span>-->
<!--                            </b-form-group>-->
<!--                        </b-col>-->

                        <b-col cols="12">
                            <b-form-group label-for="newPassword">{{$t('profil.modal.new')}}
                                <b-form-input v-validate="'required'" v-model="user.newPassword" id="newPassword" ref="newPassword" type="password" size="md" name="newPassword"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('changePassword.newPassword') }}</span>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label-for="ConfirmPassword">{{$t('profil.modal.conf')}}
                                <b-form-input id="confirmPassword"
                                              type="password"
                                              size="md"
                                              name="confirmPassword"
                                              v-validate="'required|confirmed:newPassword'"
                                              v-model="confirmedPassword"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('changePassword.confirmPassword') }}</span>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="float-right">
                        <b-button type="submit" variant="primary" :disabled="veeErrors.any('changePassword')" ref="btnChange">{{$t('profil.modal.button')}}</b-button>
                    </b-row>

                </b-form>
            </b-col>
        </b-modal>
    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'profile',
        data() {
            return {
                user: {},
                printError: ('toast.printError'),
                pass: ('toast.pass'),
                confirmedPassword: null,
            }
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            changePassword: function() {
                this.$validator.validateAll('changePassword').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('changePassword',
                            this.user
                        ).then(response => {
                            if(response.data.success) {
                                this.$toasted.show(this.$t(this.pass));
                                this.$root.$emit('bv::hide::modal', 'changePassword', '#btnChange');
                                this.user.newPassword = '';
                                this.confirmedPassword = '';
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                });
            },
        },

        created() {
            this.$axios.get('user'
            ).then(response => {
                if (response.status === 200) {
                    this.user = response.data.data;
                }
            })
        },
    };
</script>
